import { DataTableComp } from "../Common/DataTable";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { IconButton, Tooltip } from "@mui/material";
import { Download, Edit, RemoveRedEye } from "@mui/icons-material";
import EditReport from "./Edit"
import { saveAs } from 'file-saver';
import ReportDownloadView from "./ReportDownloadView";
import { pdf } from "@react-pdf/renderer";
import ReportDownloadViewOE from "./ReportDownloadViewOE";
import debounce from 'lodash/debounce';
import { useCallback } from "react";

var moment = require('moment');

export default function Assessments() {
    const [assessments, setAssessments] = useState([]);
    const [show, setShow] = useState(false);
    const [editId, setEditId] = useState(0);
    const [assessmentId, setAssessmentId] = useState(0);
    const [isReportLoading, setIsReportLoading] = useState(false)
    const [searchText, setSearchText] = useState('');
    const pageNumbers = useRef({});
    const linkRef = useRef(null);
    const renderedPages = useRef({});

    useEffect(() => {
        // getSubjects()
        getAssessments()
    }, [])

    // const getSubjects = (organizationId = '') => {
    //     axios.get(`/api/subjects?organizationId=${organizationId}`)
    //     .then(function (response) {
    //         let result = response.data;
    //         if(result.success){
    //             setSubjects(result.data)
    //         }
    //     })
    // }
    const getAssessments = (search = '') => {
        axios.get(`/api/assessments?isReportGenerated=1&search=${search}`)
            .then(function (response) {
                let result = response.data;
                if (result.success) {
                    setAssessments(result.data)
                }
            })
    }

    const debouncedSearch = useCallback(
        debounce((value) => {
            getAssessments(value);
        }, 500),
        []
    );

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        debouncedSearch(value);
    };
    const handleReset = () => {
        setSearchText('');
        getAssessments();
    };

    const handleChangeSubject = (event, value) => {
        // console.log("Autocomplete value",value)
        if (value && value.id) {
            getAssessments(value.id)
        }
        else {
            getAssessments()
        }
    }

    const arrayBufferToBase64 = (buffer) => {
        const bytes = new Uint8Array(buffer);
        const binary = Array.from(bytes, byte => String.fromCharCode(byte)).join('');
        return window.btoa(binary);
    };

    // First pass to capture page numbers
    const handlePageRender = (sectionName) => ({ pageNumber }) => {
        const key = `${sectionName}_${pageNumber}`;

        // ignore duplicate render calls
        if (renderedPages.current[key]) return;
        renderedPages.current[key] = true;

        const current = pageNumbers.current[sectionName];

        if (!current) {
            pageNumbers.current[sectionName] = {
                start: pageNumber,
                end: pageNumber
            };
        } else {
            pageNumbers.current[sectionName] = {
                start: Math.min(current.start, pageNumber),
                end: Math.max(current.end, pageNumber)
            };
        }
    };

    const handleDownload = async (e, subjectId, isOnlyOpenEndedReport, isView = false) => {
        // e.preventDefault();
        setIsReportLoading(true)
        try {
            const response = await axios.get(`/api/getReport?subjectId=${subjectId}`);
            const result = response.data;
            if (result.success) {
                // console.log('result', result.data);
                // setReport(result.data)   
                pageNumbers.current = {};
                renderedPages.current = {}
                const blob = await pdf((
                    isOnlyOpenEndedReport ? 
                    <ReportDownloadViewOE report={result.data} onPageRender={handlePageRender}/>
                    :
                    <ReportDownloadView report={result.data} onPageRender={handlePageRender}/>
                )).toBlob();

                if(isView){
                    localStorage.setItem('FF-report-page-no-'+subjectId, JSON.stringify(pageNumbers));
                    setIsReportLoading(false)
                    // let redirectTo = isOnlyOpenEndedReport ? "/report_view_open_ended/"+ subjectId : "/report_view/" + subjectId
                    // // linkRef.current.click();

                    // const link = document.createElement("a");
                    // link.href = redirectTo;
                    // link.target = "_blank";
                    // // link.rel = "noopener noreferrer";
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                }
                else{
                    const blobSecond = await pdf((
                        isOnlyOpenEndedReport ? 
                        <ReportDownloadViewOE report={result.data} pageNumbers={pageNumbers}/>
                        :
                        <ReportDownloadView report={result.data} pageNumbers={pageNumbers}/>
                    )).toBlob();
                    saveAs(blobSecond, result.data.subjectName + ".pdf");
                }
                
                
            }
            setIsReportLoading(false)
        }
        catch (error) {
            console.error('Error fetching executive summary:', error);
            setIsReportLoading(false)
        }
    }

    const columns = [
        {
            name: 'Assessment',
            selector: row => row.assessment.name,
            sortable: true,
            width: '22%',
            wrap: true
        },
        {
            name: 'Organization',
            selector: row => row.assessment.team.name,
            sortable: true,
        },
        {
            name: 'Subject',
            selector: row => row.firstName + ' ' + row.lastName,
            sortable: true,
        },
        {
            name: 'Sent Date',
            cell: row => (
                <label>{row.assessment.sentAt ? moment(row.assessment.sentAt).format('MM/DD/YYYY') : '-'}</label>
            ),
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <Tooltip title="Edit Report" size='small' className='icon icon-sm icon-secondary' onClick={() => handleEdit(row.id, row.assessmentId)}>
                        <IconButton>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Link className="bx b bx-eye-o text-white m-2" onClick={(e) => handleDownload(e, row.id, row.isOnlyOpenEndedReport, true)} to={row.isOnlyOpenEndedReport ? "/report_view_open_ended/"+ row.id : "/report_view/" + row.id} target="_blank" >
                        <Tooltip title="View Report" size='small' className='icon icon-sm icon-secondary' >
                            <IconButton>
                                <RemoveRedEye />
                            </IconButton>
                        </Tooltip>
                    </Link>
                    <Tooltip title="Download" size='small' className='icon icon-sm icon-secondary' onClick={(e) => handleDownload(e, row.id, row.isOnlyOpenEndedReport)}>
                        <IconButton>
                            <Download />
                        </IconButton>
                    </Tooltip>
                    {/* <Link ref={linkRef} rel="noopener noreferrer" style={{display: 'none'}} className="bx b bx-eye-o text-white m-2" to={row.isOnlyOpenEndedReport ? "/report_view_open_ended/"+ row.id : "/report_view/" + row.id} target="_blank">
                        Open Report
                    </Link> */}
                    {/* <PDFDownloadLink document={<ReportDownloadView subjectId={row.id} />} fileName={row.firstName+' '+row.lastName+".pdf"}>
                {({ blob, url, loading, error }) =>
                    loading ? '' : 
                    <Tooltip title="Download" size='small' className='icon icon-sm icon-secondary'>
                        <IconButton>
                            <Download />
                        </IconButton>
                    </Tooltip>
                }
                </PDFDownloadLink>  */}

                </>
            )
        },
    ];

    const handleEdit = (id, assessmentId) => {
        setEditId(id);
        setAssessmentId(assessmentId)
        setShow(true);
    }

    return (
        <Layout>
            <Header pageTitle="Reports" />
            {
                isReportLoading ? 
                <div className="loader-center">
                    <div className="spinner-border text-white" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                : ''
            }
            
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="">
                    <div className="card-header ">
                        <div className="row align-items-center">
                            <div className="col-lg-9 col-md-6 col-sm-12 col-xs-12 mb-Rg-3">
                                <h3 className="fw-bold mb-0">Reports</h3>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 text-end mb-Rg-3">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control pe-5"
                                        placeholder="Search Assessment / Org / Subject"
                                        value={searchText}
                                        onChange={handleSearch}
                                    />

                                    {searchText && (
                                        <span
                                            onClick={handleReset}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                color: '#999'
                                            }}
                                        >
                                            ✖
                                        </span>
                                    )}
                                </div>
                                {/* <Autocomplete
                                    id="combo-box-demo-subject"
                                    sx={{ width: 'auto' }}
                                    size='small'
                                    options={subjects}
                                    getOptionLabel={(option) => option.name}
                                    onChange={handleChangeSubject}
                                    renderInput={(params) => <TextField {...params} label={"Select Subject"} />}    
                                /> */}
                            </div>
                        </div>
                    </div>
                    <div className="table">
                        <div className="">
                            <DataTableComp columns={columns} data={assessments} isIndex={true} />
                        </div>
                    </div>
                </div>
            </div>
            <EditReport editId={editId} assessmentId={assessmentId} show={show} setShow={setShow} />
        </Layout>
    )
}